import { useMemo } from "react";
import { useQuery } from "@apollo/client";

import {
  GetProductCategoriesDocument,
  GetProductCategoriesLengthDocument,
  GetProductCategoriesLengthQuery,
  GetProductCategoriesLengthQueryVariables,
  GetProductCategoriesQuery,
  GetProductCategoriesQueryVariables,
} from "../graphql/queries/__generated__/products.query";

const useGetProductCategories = (
  variables: GetProductCategoriesQueryVariables,
  options?: { skip?: boolean }
) => {
  const skip = options?.skip ?? false;
  const lengthVariables = useMemo(
    () => ({
      filter: variables.filter,
    }),
    [variables.filter]
  );

  const { data, loading, error, fetchMore, networkStatus } = useQuery<
    GetProductCategoriesQuery,
    GetProductCategoriesQueryVariables
  >(GetProductCategoriesDocument, {
    fetchPolicy: "cache-first",
    variables,
    skip,
  });

  const { data: _data, error: _error } = useQuery<
    GetProductCategoriesLengthQuery,
    GetProductCategoriesLengthQueryVariables
  >(GetProductCategoriesLengthDocument, {
    fetchPolicy: "cache-first",
    variables: lengthVariables,
    skip,
  });

  return {
    categories: data?.getProductCategories ?? [],
    count: (!_error ? _data?.getProductCategoriesLength : 0) ?? 0,
    loading,
    error,
    fetchMore,
    networkStatus,
  };
};

export default useGetProductCategories;
